import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Home} from './pages/home/home';
import {Solutions} from './pages/solutions/solutions';
import {Pricing} from './pages/pricing/pricing';
import {Shows} from './pages/shows/shows';
import {Clinics} from './pages/clinics/clinics';
import {EventDetails} from './pages/event-details/event-details';
import {Results} from './pages/results/results';
import {News} from './pages/news/news';
import {Membership} from './pages/membership/membership';
import {Rulebook} from './pages/rulebook/rulebook';
import {About} from './pages/about/about';
import {LayoutComponent} from './pages/auth/layout/layout.component';
import {RegisterUserComponent} from './pages/auth/register-user/register-user.component';
import {LoginComponent} from './pages/auth/login/login.component';
import {ForgotPassordComponent} from './pages/auth/forgot-passord/forgot-passord.component';
import {ResetPasswordComponent} from './pages/auth/reset-password/reset-password.component';
import {VerifyEmail} from './pages/auth/verify-email/verify-email';
import {UserProfile} from './pages/user-profile/user-profile';
import {AuthGuard} from './@core/guards/auth.guard';
import {CompanyProfile} from './pages/company-profile/company-profile';
import {AddEvent} from './pages/company-profile/components/company-profile-events/components/add-event/add-event';
import {
  ManageEvent
} from './pages/company-profile/components/company-profile-events/components/manage-event/manage-event';
import {
  CreateEventWizard
} from './pages/company-profile/components/company-profile-events/components/create-event-wizard/create-event-wizard';
import {
  LiveSessionControl
} from './pages/company-profile/components/company-profile-events/components/manage-event/components/live-session-control/live-session-control';
import {EventRegistrationComponent} from './pages/event-registration/event-registration';
import {RegistrationSuccessComponent} from './pages/event-registration/components/registration-success/registration-success';
import {PrivacyPolicy} from './pages/legal/privacy-policy/privacy-policy';
import {TermsOfService} from './pages/legal/terms-of-service/terms-of-service';
import {CookiePolicy} from './pages/legal/cookie-policy/cookie-policy';
import {ChatComponent} from './pages/chat/chat.component';
import {Organisations} from './pages/organisations/organisations';
import {OrganisationDetails} from './pages/organisation-details/organisation-details';
import {Trainers} from './pages/trainers/trainers';
import {TrainerDetails} from './pages/trainer-details/trainer-details';
import {StoreLocator} from './pages/store-locator/store-locator';
import {StoresServices} from './pages/stores-services/stores-services';
import {NryfEventDetails} from './pages/nryf-event-details/nryf-event-details';
import {Admin} from './pages/admin/admin';
import {AdminGuard} from './@core/guards/admin.guard';

const routes: Routes = [
  { path: '', component: Home, pathMatch: 'full'},
  { path: 'solutions', component: Solutions, pathMatch: 'full'},
  { path: 'pricing', component: Pricing, pathMatch: 'full'},
  { path: 'shows', component: Shows, pathMatch: 'full'},
  { path: 'clinics', component: Clinics, pathMatch: 'full'},
  { path: 'trainers', component: Trainers, pathMatch: 'full'},
  { path: 'trainers/:id', component: TrainerDetails },
  { path: 'organisations', component: Organisations, pathMatch: 'full'},
  { path: 'organisations/:id', component: OrganisationDetails },
  { path: 'store-locator', component: StoreLocator, pathMatch: 'full'},
  { path: 'stores-services', component: StoresServices, pathMatch: 'full'},
  { path: 'stores-services/:id', component: OrganisationDetails },
  { path: 'event-details/:id', component: EventDetails },
  { path: 'nryf-event/:id', component: NryfEventDetails },
  { path: 'event-registration/:eventId', component: EventRegistrationComponent, canActivate: [AuthGuard] },
  { path: 'event-registration/:eventId/success', component: RegistrationSuccessComponent, canActivate: [AuthGuard] },
  { path: 'results', component: Results, pathMatch: 'full'},
  { path: 'news', component: News, pathMatch: 'full'},
  { path: 'membership', component: Membership, pathMatch: 'full'},
  { path: 'rulebook', component: Rulebook, pathMatch: 'full'},
  { path: 'about', component: About, pathMatch: 'full'},
  { path: 'privacy-policy', component: PrivacyPolicy, pathMatch: 'full'},
  { path: 'terms-of-service', component: TermsOfService, pathMatch: 'full'},
  { path: 'cookie-policy', component: CookiePolicy, pathMatch: 'full'},
  { path: 'auth', component: LayoutComponent, children: [
      { path: 'login', component: LoginComponent },
      { path: 'register-user', component: RegisterUserComponent},
      { path: 'verify-email', component: VerifyEmail},
      { path: 'forgot-password', component: ForgotPassordComponent},
      { path: 'reset-password', component: ResetPasswordComponent}
    ]
  },
  { path: 'user-profile', component: UserProfile, canActivate: [AuthGuard] },
  { path: 'chat', component: ChatComponent, canActivate: [AuthGuard] },
  { path: 'company-profile', component: CompanyProfile, canActivate: [AuthGuard] },
  { path: 'company-profile/add-event', component: AddEvent, canActivate: [AuthGuard] },
  { path: 'company-profile/create-event/:companyId', component: CreateEventWizard, canActivate: [AuthGuard] },
  { path: 'company-profile/manage-event/:id', component: ManageEvent, canActivate: [AuthGuard] },
  { path: 'manage-event/:id', component: ManageEvent, canActivate: [AuthGuard] },
  { path: 'company-profile/events/:event_id/live/:schedule_id', component: LiveSessionControl, canActivate: [AuthGuard] },
  { path: 'admin', component: Admin, canActivate: [AdminGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
